import React from 'react';
import './AboutWelcome.css';

const AboutWelcome = ({ settings = {} }) => {
  console.log('AboutWelcome settings:', settings);
  
  const {
    title = 'HERZLICH WILLKOMMEN',
    subtitle = 'DIE KÜCHE UNSERER MÜTTER',
    decorative_symbol = '◆◆◆',
    content = `Zu Zeiten der Seidenstrasse bildete die Region "Bilad esh-Sham", wie die Länder Syrien, Libanon, Palästina und Jordanien genannt wurden, einen wichtigen Knotenpunkt und war Durchzugsgebiet für unzählige Völker und Karawanen. Über die Jahrhunderte sickerten verschiedenste Einflüsse in die Koch- und Esstradition dieser Gegend ein.

So stammen aus der persischen Küche jene Gerichte, bei denen Gemüse wie etwa Weinblätter, Zucchini oder Auberginen und auch Teigtaschen gefüllt werden.

In der armenischen Küche entstand die Tradition der Fleischkonservierung und Wurstproduktion. Die scharfen Gerichte haben ihren Ursprung eher in der kurdischen Tradition, ebenso der Einsatz von Gewürzen, die über Südostasien in die Gegend gebracht wurden.

In diesem Klima des Austausches und des regen Handels, entstand in Verbindung mit den lokalen Gegebenheiten, die Küche unserer Mütter.

Sie hat uns geprägt und sie ist es, die uns Heimweh und Entfernung vergessen lässt und uns immer wieder aufs Neue Kraft gibt für den Alltag in der Diaspora. Weit weg von Bethlehem, Beirut und Damaskus.

Wir hoffen, auch Sie werden sich bei uns heimisch fühlen und wünschen Ihnen einen guten Appetit.`,
    background_image = '',
    backgroundImage = '', // camelCase version from Hero
    background_image_debug = '',
    background_color = '#ffffff',
    text_color = '#333333',
    accent_color = '#4A90E2',
    overlay_opacity = 0.7,
    text_background_opacity = 0.9
  } = settings;

  console.log('Background image:', background_image);
  console.log('Background Image (camelCase):', backgroundImage);
  console.log('Background image debug:', background_image_debug);
  console.log('Background color:', background_color);
  console.log('All settings:', settings);

  const formatContent = (text) => {
    return text.split('\n\n').map((paragraph, index) => (
      <p key={index} className="about-welcome__paragraph">
        {paragraph}
      </p>
    ));
  };

  // Force a test image for now
  const testImage = 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=1920&h=1080&fit=crop&crop=center';
  const finalBackgroundImage = background_image || backgroundImage || testImage;
  
  console.log('Final background image:', finalBackgroundImage);
  console.log('Setting background to:', testImage);
  
  const sectionStyle = {
    backgroundColor: 'transparent',
    color: text_color,
    backgroundImage: `url(${testImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    minHeight: '100vh'
  };

  console.log('Section style:', sectionStyle);
  console.log('Final background image:', finalBackgroundImage);

  const hasBackgroundImage = finalBackgroundImage !== '';
  
  return (
    <section 
      className={`about-welcome ${hasBackgroundImage ? 'about-welcome--with-bg' : 'about-welcome--no-bg'}`} 
      style={sectionStyle}
    >
      {hasBackgroundImage && (
        <div className="about-welcome__overlay" style={{ opacity: overlay_opacity }}></div>
      )}
      
      <div className="about-welcome__container">
        <div className="about-welcome__header">
          <h1 className="about-welcome__title" style={{ color: hasBackgroundImage ? '#ffffff' : accent_color }}>
            {title}
          </h1>
          <div className="about-welcome__decorative" style={{ color: hasBackgroundImage ? '#ffffff' : accent_color }}>
            {decorative_symbol}
          </div>
        </div>
        
        <div className="about-welcome__content">
          <div 
            className={`about-welcome__content-wrapper ${hasBackgroundImage ? 'about-welcome__content-wrapper--with-bg' : ''}`}
            style={{
              backgroundColor: hasBackgroundImage ? `rgba(255, 255, 255, ${text_background_opacity})` : 'transparent'
            }}
          >
            <h2 className="about-welcome__subtitle" style={{ color: accent_color }}>
              {subtitle}
            </h2>
            <div className="about-welcome__text" style={{ color: hasBackgroundImage ? '#333' : text_color }}>
              {formatContent(content)}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutWelcome;